<div class="grid">
  <div class="col-12">
    <div class="card">
      <p-table #dt
               [value]="miniliens"
               dataKey="id"
               [lazy]="true"
               (onLazyLoad)="loadDatas($event)"
               [rows]="10"
               [loading]="loading"
               [rowHover]="true"
               [totalRecords]="totalRecords"
               styleClass="p-datatable-gridlines"
               [paginator]="true"
                [rowsPerPageOptions]="[5,10,20,100,250,500]"
               responsiveLayout="scroll">
        <ng-template pTemplate="caption">
          <div class="flex justify-content-right flex-column sm:flex-row">
            <button pButton
                    label="Clear"
                    class="p-button-outlined mb-2 mr-2"
                    icon="pi pi-filter-slash"
                    (click)="clear(dt)"></button>
            <p-button   [disabled]="(degradedModeService.isDegradedMode() | async) ?? false"  *ngIf="userService.canEdit()" (click)="showDialog()" icon="pi pi-plus" ></p-button>
<!--            <button type="button"-->
<!--                    pButton-->
<!--                    pRipple-->
<!--                    icon="pi pi-filter"-->
<!--                    (click)="dt.exportCSV({ selectionOnly: true })"-->
<!--                    class="p-button-info ml-auto"-->
<!--                    pTooltip="Selection Only"-->
<!--                    tooltipPosition="bottom"></button>-->

          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>
              <div class="flex justify-content-between align-items-center">
                Code Article
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Ouvrage
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Page d'atterrissage
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                URL courte
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                URL longue
              </div>
            </th>

            <th *ngIf="userService.canEdit()">
              <div class="flex justify-content-between align-items-center">
              </div>
            </th>
          </tr>
          <tr>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="codeArticle"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="TitreWeb"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="idPage"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="url_courte"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="url_longue"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>

            <th *ngIf="userService.canEdit()">
              <div class="flex justify-content-between align-items-center">
              </div>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body"
                     let-minilien>
          <tr>
            <td style="min-width: 12rem;">
              {{minilien.codeArticle }}
            </td>

            <td style="min-width: 12rem;">
              {{minilien.TitreWeb}}
            </td>

            <td style="min-width: 12rem;">
              {{minilien.idPage}}
            </td>

            <td style="min-width: 12rem;">
              {{minilien.url_courte}}
            </td>

            <td style="min-width: 12rem;">
              {{minilien.url_longue}}
            </td>

            <td *ngIf="userService.canEdit()">
              <p-button
                [disabled]="(degradedModeService.isDegradedMode() | async) ?? false"
                icon="pi pi-file-edit" (click)="editMinilien(minilien.id, minilien.url_courte, minilien.url_longue)">
              </p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog
  header="{{formType === 'create' ? 'Ajouter un minilien' : 'Editer le minilien'}}"
  [modal] = "true"
  [(visible)]="visible"
  [style]="{width: '50vw'}">
    <form name="form"
            [formGroup]="form"
            (ngSubmit)="onSubmit()"
      >
        <div>
          <label for="url_courte"
                 class="block text-900 font-medium mb-2 mt-2">url_courte</label>
          <input type="text"
                 name="url_courte"
                 id="url_courte"
                 formControlName="url_courte"
                 class="form-control w-full mb-3">
          <div *ngIf="submitted && form.controls.url_courte.invalid && (form.controls.url_courte.dirty || form.controls.url_courte.touched)"
               class="alert alert-danger">
            <div *ngIf="form.controls.url_courte.errors?.['required']">
              url_courte is required.
            </div>
          </div>
        </div>

        <div>
          <label for="url_longue"
                 class="block text-900 font-medium mb-2">url_longue</label>
          <input type="text"
                 name="url_longue"
                 id="url_longue"
                 formControlName="url_longue"
                 class="w-full mb-3">
          <div *ngIf="submitted && form.controls.url_longue.invalid && (form.controls.url_longue.dirty || form.controls.url_longue.touched)"
               class="alert alert-danger">
            <div *ngIf="form.controls.url_longue.errors?.['required']">
              url_longue is required.
            </div>
          </div>
        </div>

        <input type="hidden" name="id" formControlName="id">

        <div>
          <button pButton>{{formType === 'create' ? 'Ajouter' : 'Editer'}}</button>
        </div>
        <div *ngFor="let error of errors">
          <div class="alert alert-danger">{{error}}</div>
        </div>
      </form>
</p-dialog>

<p-toast key="messages"></p-toast>
